import React from "react";
function QuestionTypePopup({ setOpenQuestionsPopup }) {
    return (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <img className="prereadLoader" src="/images/alert.svg" alt="icon" style={{ width: "60px", height: "60px", margin: "auto" }} />
                    </div>
                    <div className="modal-body" style={{ fontSize: "17px", fontWeight: "500" }}>
                        {"You can't create question right now because the system needs specific question types that haven't been set up yet. This data is defined in your institution's main web application."}
                    </div>
                    <hr style={{ margin: "15px 0px" }} />
                    <div>
                        <button type="button" className="btn btn-secondary" style={{ float: "right" }} onClick={() => {
                            setOpenQuestionsPopup(false)
                        }}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuestionTypePopup;
